// Holds the JWT issued by verifyOTP so the axios request interceptor can
// attach it to subsequent calls (updateOrder/editOrder). Not a security
// boundary: the token expires server-side after 1h.
const STORAGE_KEY = "preorder_auth_token";

let inMemoryToken: string | null = null;

export function setAuthToken(token: string | null): void {
  inMemoryToken = token;
  try {
    if (token) {
      sessionStorage.setItem(STORAGE_KEY, token);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // sessionStorage unavailable (e.g. private browsing) - in-memory token still works
  }
}

export function getAuthToken(): string | null {
  if (inMemoryToken) return inMemoryToken;
  try {
    inMemoryToken = sessionStorage.getItem(STORAGE_KEY);
  } catch {
    inMemoryToken = null;
  }
  return inMemoryToken;
}

export function clearAuthToken(): void {
  setAuthToken(null);
}
